import X from "lucide-react/dist/esm/icons/x";
import type { Notice } from "../use-game";

export function Toast({ notice, onDismiss }: { notice: Notice; onDismiss: () => void }) {
  return (
    <div className={`toast toast--${notice.kind}`} role="status" aria-live="polite">
      <span>{notice.message}</span>
      <button type="button" onClick={onDismiss} aria-label="Cerrar aviso">
        <X aria-hidden="true" size={18} />
      </button>
    </div>
  );
}
